var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-overlay',{attrs:{"value":_vm.show,"light":true,"dark":false}},[_c('v-container',{staticClass:"fill-height d-flex align-center"},[_c('end-user-license-agreement')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }